import { createContext, useEffect, useState } from "react";
import axios from "../axios";

export const AuthContext = createContext();

export default function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = belum login
  const [loading, setLoading] = useState(true);

  const fetchUser = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setUser(null);
        setLoading(false);
        return;
      }
      
      const res = await axios.get("/me"); // API: /api/me
      setUser(res.data);
    } catch (err) {
      console.error("Fetch user error:", err);
      // If unauthorized, remove invalid token
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
      }
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

//   useEffect(() => {
//     fetchUser();
//   }, []);

const logout = () => {
  localStorage.removeItem("token");
  setUser(null);
};

useEffect(() => {
    const token = localStorage.getItem("token");
    console.log('Token from localStorage:', token);
    if (token) {
      fetchUser();
    } else {
      setLoading(false); // ⛔ Tidak fetch user kalau tidak ada token
    }
  }, []);


  return (
    <AuthContext.Provider value={{ user, setUser, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
